<template>
	<v-dialog v-model="dialog" max-width="500" persistent>
		<v-card>
			<v-toolbar flat dense cad color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">Approve Position Description</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text>
				<div class="pt-3 pb-2">Please confirm that you want to approve this position description.</div>
				<div class="mt-3 disclaimer">
					The employee will also have to acknowledge the position description before it becomes live, this can only be done after approval.
				</div>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-spacer></v-spacer>
				<v-btn :disabled="isApproving" flat @click="onCancel">Cancel</v-btn>
				<v-btn :disabled="isApproving" :loading="isApproving" color="primary" flat @click="onApprove">Approve <span slot="loader">Please Wait...</span></v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
			isApproving: {
				type: Boolean,
				required: false
			}
		},
		data() {
			return {};
		},
		methods: {
			onApprove() {
				this.$emit('onApprove');
			},
			onCancel() {
				this.$emit('onCancel');
			}
		}
	};
</script>

<style scoped>
	.disclaimer {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px !important;
	}
</style>